module.exports = __webpack_public_path__ + "pic2.jpg?ced21af794c1a161e730832b549af887";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/featured/pic2.jpg
// module id = 60
// module chunks = 13